import { useGetList } from "ra-core";

import type { Pipeline, PipelineStage } from "../types";

// Pipeline padrão exibido pelo Kanban quando não há seleção do usuário.
// O banco já tem dois pipelines reais ('triagem_contatos' e
// 'comercial_faromarket'); o Comercial foi a escolha de UX para o board
// principal (Fase A — 2026-05-17).
export const DEFAULT_PIPELINE_SLUG = "comercial_faromarket";

// Chave de persistência local do pipeline selecionado no Kanban — sobrevive
// a navegação dentro da SPA sem precisar tocar no localStorage de ra-core
// (que é compartilhado entre vários app states).
export const KANBAN_PIPELINE_STORAGE_KEY = "fm.kanban.pipeline_slug";

/** Lista os pipelines ativos, ordenados por sort_order. */
export const usePipelines = () =>
  useGetList<Pipeline>("pipelines", {
    pagination: { page: 1, perPage: 50 },
    sort: { field: "sort_order", order: "ASC" },
    filter: { is_active: true },
  });

/**
 * Lista as stages ATIVAS de um pipeline, ordenadas por sort_order.
 * Quando pipelineId vem undefined, a query fica desativada (útil para
 * evitar fetch antes do seletor decidir o pipeline corrente).
 */
export const usePipelineStages = (pipelineId: number | undefined) =>
  useGetList<PipelineStage>(
    "pipeline_stages",
    {
      pagination: { page: 1, perPage: 100 },
      sort: { field: "sort_order", order: "ASC" },
      filter: pipelineId
        ? { pipeline_id: pipelineId, is_active: true }
        : { is_active: true },
    },
    { enabled: pipelineId != null },
  );

/** Resolve slug→label para exibição em cards/badges. */
export const findStageLabel = (
  stages: PipelineStage[] | undefined,
  slug: string | null | undefined,
): string => {
  if (!slug) return "";
  return stages?.find((s) => s.slug === slug)?.label ?? slug;
};
